import React from "react";
import { Text } from "react-native";
import { colors } from "../constants/colors";

export const BaseLargeText = (props) => {
  return (
    <Text
      {...props}
      style={[{ fontSize: 32, color: colors.grey }, props.style]}
    >
      {props.children}
    </Text>
  );
};
